// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-PropertiesEditor {
  width: 100%;
}
.x-PropertiesEditor td {
  border: 1px solid #ccc;
  padding: 1px 5px;
}
.x-PropertiesEditor td.x-PropertiesEditor-name {
  width: 200px;
  font-weight: bold;
}
.x-PropertiesEditor td.x-PropertiesEditor-caption {
  font-weight: bold;
  background-color: #d2d7ee;
}
.x-PropertiesEditor td.x-PropertiesEditor-value > * {
  width: 100%;
}
.x-PropertiesEditor td.x-PropertiesEditor-value input {
  border: none;
}
.x-PropertiesEditor-collapseBtn {
  cursor: pointer;
}
.x-PropertiesEditor-collapseBtn:hover {
  color: #00739d;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/editor/PropertiesEditor.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAFA;EAGI,sBAAA;EACA,gBAAA;AAEJ;AANA;EAOI,YAAA;EACA,iBAAA;AAEJ;AAVA;EAWI,iBAAA;EACA,yBAAA;AAEJ;AACI;EACE,WAAA;AACN;AAjBA;EAmBM,YAAA;AACN;AAIA;EACE,eAAA;AAFF;AAGE;EACE,cAAA;AADJ","sourcesContent":[".root {\n  width: 100%;\n  td {\n    border: 1px solid #ccc;\n    padding: 1px 5px;\n  }\n  td.name {\n    width: 200px;\n    font-weight: bold;\n  }\n  td.caption {\n    font-weight: bold;\n    background-color: #d2d7ee;\n  }\n  td.value {\n    & > * {\n      width: 100%;\n    }\n    input {\n      border: none;\n    }\n  }\n}\n\n.collapseBtn {\n  cursor: pointer;\n  &:hover {\n    color: #00739d;\n  }\n}\n\n.splitter {\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `x-PropertiesEditor`,
	"name": `x-PropertiesEditor-name`,
	"caption": `x-PropertiesEditor-caption`,
	"value": `x-PropertiesEditor-value`,
	"collapseBtn": `x-PropertiesEditor-collapseBtn`
};
export default ___CSS_LOADER_EXPORT___;
